import Vue from 'vue'
import Router from 'vue-router'
import FeedBack from '../page/feedBack/FeedBack'
import Success from '../page/success/Success'

Vue.use(Router)

export default new Router({
  routes: [
    {
        path: '/',
        name: 'FeedBack',
        component: FeedBack
    },
    {
        path: '/success',
        name: 'success',
        component: Success
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js